module.exports = __webpack_public_path__ + "static/img/link-5.6847ad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/foot-view/link-5.jpg
// module id = NGTr
// module chunks = 8 9